import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input} from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { SideNavService } from '../../services/side-nav.service';
import { NavItem } from '../nav-item';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuListItemComponent  {
  expanded: boolean = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem;
  @Input() depth: number;

  constructor(
    public router: Router,
    public sharedService: SharedService,
    public sideNavService: SideNavService) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  public onItemSelected(item: NavItem) {
    if(this.sharedService.mobileSize){
      this.sideNavService.toggle();
      this.sharedService.showButton=true;
      this.sharedService.showButton2=true;
    }
    this.sharedService.menuItemSeleccionado = item;
    if (!item.items || !item.items.length) {
      if(item.link=='AGREGAR_OBJETIVO' || item.link=='AGREGAR_AVANCE'){
          console.log("Entro a mostrar pop module")
          this.sharedService.onMenuItemClick.next(item);
      }else{
        this.router.navigate([item.link],{ skipLocationChange: true });
      }
    }
    if (item.items && item.items.length) {
      this.expanded = !this.expanded;
    }
  }

}
